import React, { useEffect, useState } from 'react';
import { getHistoryDateSummary } from '../../../actions/adminActions';
import { useSelector, useDispatch } from 'react-redux';
import HistoryDateHistogram from './HistoryDateHistogram';

const AdminHome = () => {
    const dispatch = useDispatch();
    const adminState = useSelector((state) => state.admin);
    const { historyDateSummary = {} } = adminState;
    const [fetchingHistorySummary, setFetchingHistorySummary] = useState(true);

    useEffect(() => {
        dispatch(getHistoryDateSummary()).finally(() => setFetchingHistorySummary(false));
    }, [dispatch]);

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}>
            <HistoryDateHistogram {...historyDateSummary} loading={fetchingHistorySummary} />
        </div>
    );
};

export default AdminHome;
